import * as React from "react";
import { RiAddLine, RiSubtractLine } from "@remixicon/react";
import { cn } from "~/lib/utils";

export interface NumberPickerProps {
  value: number;
  onIncrement: () => void;
  onDecrement: () => void;
  min?: number;
  max?: number;
  disabled?: boolean;
  className?: string;
}

const NumberPicker = React.forwardRef<HTMLDivElement, NumberPickerProps>(
  ({ value, onIncrement, onDecrement, min = 0, max = Infinity, disabled = false, className }, ref) => (
    <div
      ref={ref}
      className={cn(
        "flex h-10 w-[95px] items-center justify-between overflow-hidden rounded-md border border-input bg-background",
        className,
      )}
    >
      <button
        type="button"
        onClick={onDecrement}
        disabled={disabled || value <= min}
        aria-label="Decrease quantity"
        className="hover:bg-muted flex h-full w-9 shrink-0 cursor-pointer items-center justify-center rounded-l-md p-2 disabled:cursor-not-allowed disabled:opacity-50"
      >
        <RiSubtractLine className="size-5" />
      </button>
      <span className="text-body flex-1 overflow-hidden px-2 text-center text-sm">{value}</span>
      <button
        type="button"
        onClick={onIncrement}
        disabled={disabled || value >= max}
        aria-label="Increase quantity"
        className="hover:bg-muted flex h-full w-9 shrink-0 cursor-pointer items-center justify-center rounded-r-md p-2 disabled:cursor-not-allowed disabled:opacity-50"
      >
        <RiAddLine className="size-5" />
      </button>
    </div>
  ),
);
NumberPicker.displayName = "NumberPicker";

export { NumberPicker };
